import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "./services/auth.service";

/**
 * GUARD 1: Protects authenticated routes (requires login).
 * Checks local isLoggedIn signal; backend validates session on every API call
 * via authInterceptor which triggers logout on 401.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn()) {
    return true;
  }
  return router.createUrlTree(["/"]);
};

/**
 * GUARD 2: Protects guest routes (prevents logged-in users from accessing).
 * Example: Landing page should not be visible to authenticated users.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn()) {
    return router.createUrlTree(["/home"]);
  }

  return true;
};
